<template>

    <div class="splash__players__names">

        <div class="splash__players__team">

            <div class="splash__player__name">
                <h2>{{initial(info.nAF)}}&nbsp;{{info.nAL}}</h2>
                <img class="small-flag" :src="flagPath + info.cA.toLowerCase() + '.svg'"  :alt="info.cA">

            </div>

            <div class="splash__player__name" v-if="info.isDoubles == '1'">
                <h2>{{initial(info.nA2F)}}&nbsp;{{info.nA2L}}</h2>
                <img class="small-flag" :src="flagPath + info.cA2.toLowerCase() + '.svg'" :alt="info.cA2">

            </div>

        </div>

        <div class="MatchDetailPlayer__separator"></div>

        <div class="splash__players__team">

            <div class="splash__player__name">

                <h2>{{initial(info.nBF)}}&nbsp;{{info.nBL}}</h2>
                <img class="small-flag" :src="flagPath + info.cB.toLowerCase() + '.svg'" :alt="info.cB">

            </div>

            <div class="splash__player__name" v-if="info.isDoubles == '1'">

                <h2>{{initial(info.nB2F)}}&nbsp;{{info.nB2L}}</h2>
                <img class="small-flag" :src="flagPath + info.cB2.toLowerCase() + '.svg'" :alt="info.cB2">
                
            </div>
        </div>
    </div>


</template>

<script>

    export default {
        props: ['info', 'match', 'assoc', 'flagPath'],
        data() {
            return {
                players: window.all_players, 
                isSingle: false,
                singles: ["QS", "MS", "RS", "LS"],
            }
        },
        created() {

        },
        mounted() {

            if(this.singles.includes(this.match.substring(0, 2))){

                this.isSingle = true
            }
        },
        methods: {          
            
            
            initial(name) {
                return `${name.charAt(0)}.`
            },
            findPlayerById(playerId) {
                let found = this.players.filter(player => player.player_id == playerId)

                if (found.length == 1) {
                    return found[0]
                }

                return false
            }
        }
    }
</script>
